"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = exports.ListItemDesktop = exports.ListItem = exports.Label = exports.IntroText = exports.GitLabLink = exports.GitLabIcon = exports.ExternalSiteIcon = exports.DropdownList = exports.DropdownButton = exports.DomainListDesktop = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _mediaQueries = _interopRequireDefault(require("../../mediaQueries"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var navWrapperHeight = '48px';
var dividerStyle = /*#__PURE__*/(0, _styledComponents.css)(["content:'';height:24px;left:0;position:absolute;width:100%;"]);

var Navigation = /*#__PURE__*/_styledComponents["default"].nav.withConfig({
  displayName: "indexstyles__Navigation",
  componentId: "sc-1tzlc0e-0"
})(["box-sizing:content-box;display:flex;font-family:'Source Sans Pro',sans-serif;height:", ";justify-content:center;line-height:", ";position:relative;", " > *{align-items:center;display:flex;font-size:14px;height:100%;padding:0 ", " 0;position:relative;:first-child{color:", ";}", "}"], navWrapperHeight, function (p) {
  return p.theme.tokens.lineHeightTextSmall;
}, _mediaQueries["default"].lgUp(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    border-bottom: solid 1px;\n    border-bottom-color: ", ";\n  "])), function (p) {
  return p.theme.colorDividerSecondary;
}), function (p) {
  return p.theme.tokens.spacing05;
}, function (p) {
  return p.theme.colorTextLabel;
}, _mediaQueries["default"].lgUp(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n      padding: 0 ", ";\n    "])), function (p) {
  return p.theme.tokens.spacing06;
}));

exports.Navigation = Navigation;

var IntroText = /*#__PURE__*/_styledComponents["default"].p.withConfig({
  displayName: "indexstyles__IntroText",
  componentId: "sc-1tzlc0e-1"
})(["margin:0;", ""], _mediaQueries["default"].lgUp(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    > br {\n      display: none;\n    }\n  "]))));

exports.IntroText = IntroText;

var DropdownButton = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__DropdownButton",
  componentId: "sc-1tzlc0e-2"
})(["color:", ";cursor:pointer;font-size:14px;user-select:none;vertical-align:middle;white-space:nowrap;:before{", " border-left:solid 1px;border-left-color:", ";}> svg{margin-left:", ";}", ""], function (p) {
  return p.theme.colorText;
}, dividerStyle, function (p) {
  return p.theme.colorDividerPrimary;
}, function (p) {
  return p.theme.tokens.spacing02;
}, _mediaQueries["default"].lgUp(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    display: none;\n  "]))));

exports.DropdownButton = DropdownButton;

var DropdownList = /*#__PURE__*/_styledComponents["default"].ul.withConfig({
  displayName: "indexstyles__DropdownList",
  componentId: "sc-1tzlc0e-3"
})(["background:", ";box-shadow:0 2px 4px 0 rgba(0,0,0,0.5);display:flex;flex-direction:column;height:fit-content;margin:0;margin-top:", ";top:", ";bottom:0;padding:0;position:absolute;width:", ";z-index:15;", ""], function (p) {
  return p.theme.colorBackgroundDropdown;
}, function (p) {
  return p.theme.tokens.spacing02;
}, navWrapperHeight, function (p) {
  return "calc(100vw - ".concat(p.theme.tokens.spacing05, ")");
}, _mediaQueries["default"].lgUp(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    display: none;\n  "]))));

exports.DropdownList = DropdownList;

var Label = /*#__PURE__*/_styledComponents["default"].p.withConfig({
  displayName: "indexstyles__Label",
  componentId: "sc-1tzlc0e-4"
})(["margin:0;> span{color:", ";display:block;font-size:14px;line-height:1.5;margin-top:", ";}"], function (p) {
  return p.isActive ? p.theme.colorTextDropdownActive : p.theme.colorTextLabel;
}, function (p) {
  return p.theme.tokens.spacing02;
});

exports.Label = Label;
var ExternalSiteIcon = /*#__PURE__*/(0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "indexstyles__ExternalSiteIcon",
  componentId: "sc-1tzlc0e-5"
})(["flex-shrink:0;height:16px;margin:auto 0 auto ", ";"], function (p) {
  return p.theme.tokens.spacing03;
});
exports.ExternalSiteIcon = ExternalSiteIcon;

var ListItem = /*#__PURE__*/_styledComponents["default"].li.withConfig({
  displayName: "indexstyles__ListItem",
  componentId: "sc-1tzlc0e-6"
})(["background:", ";list-style:none;width:100%;:hover{background:", ";}> *{color:inherit;display:flex;justify-content:space-between;margin:0;padding:", ";text-decoration:inherit;:hover{color:inherit;}}", "{fill:", ";}:hover{", "{fill:", ";}", "{> span{color:", ";}}}"], function (p) {
  return p.isSelected && p.theme.colorBackgroundDropdownSelected;
}, function (p) {
  return !p.isSelected && p.theme.colorBackgroundDropdownHover;
}, function (p) {
  return "".concat(p.theme.tokens.spacing04, " ").concat(p.theme.tokens.spacing05);
}, ExternalSiteIcon, function (p) {
  return p.theme.colorTextLabel;
}, ExternalSiteIcon, function (p) {
  return p.theme.colorTextDropdownActive;
}, Label, function (p) {
  return !p.isSelected && p.theme.colorTextDropdownActive;
});

exports.ListItem = ListItem;

var DomainListDesktop = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__DomainListDesktop",
  componentId: "sc-1tzlc0e-7"
})(["display:none;", ""], _mediaQueries["default"].lgUp(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n\n    :before {\n      ", "\n      border-left: solid 1px;\n      border-left-color: ", ";\n    }\n  "])), dividerStyle, function (p) {
  return p.theme.colorDividerPrimary;
}));

exports.DomainListDesktop = DomainListDesktop;

var ListItemDesktop = /*#__PURE__*/_styledComponents["default"].a.withConfig({
  displayName: "indexstyles__ListItemDesktop",
  componentId: "sc-1tzlc0e-8"
})(["align-items:center;color:inherit;display:flex;font-weight:", ";height:100%;justify-content:center;position:relative;text-decoration:inherit;white-space:nowrap;span:first-child{position:absolute;}span:last-child{font-weight:700;opacity:0;}:hover{color:inherit;span:first-child{font-weight:700;opacity:1;}}+ a{margin-left:", ";}", ""], function (p) {
  return p.isSelected && 700;
}, function (p) {
  return p.theme.tokens.spacing07;
}, function (p) {
  return p.isSelected && "\n      :before {\n        border-bottom: solid 1px;\n        border-bottom-color: ".concat(function (p) {
    return p.theme.colorText;
  }, "\n        bottom: -1px;\n        content: '';\n        height: 100%;\n        position: absolute;\n        width: 100%;\n      }\n  ");
});

exports.ListItemDesktop = ListItemDesktop;
var GitLabIcon = /*#__PURE__*/(0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "indexstyles__GitLabIcon",
  componentId: "sc-1tzlc0e-9"
})(["height:16px;fill:", ";"], function (p) {
  return p.theme.colorText;
});
exports.GitLabIcon = GitLabIcon;

var GitLabLink = /*#__PURE__*/_styledComponents["default"].a.withConfig({
  displayName: "indexstyles__GitLabLink",
  componentId: "sc-1tzlc0e-10"
})(["color:", ";position:relative;:before{", " border-left:solid 1px;border-left-color:", ";}:hover{color:inherit;}span{display:none;}", ""], function (p) {
  return p.theme.colorText;
}, dividerStyle, function (p) {
  return p.theme.colorDividerPrimary;
}, _mediaQueries["default"].lgUp(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n    text-decoration: none;\n\n    > div {\n      display: flex;\n      justify-content: center;\n    }\n\n    span {\n      display: block;\n      margin-left: ", ";\n    }\n\n    span:first-child {\n      position: absolute;\n    }\n    span:last-child {\n      font-weight: 700;\n      opacity: 0;\n    }\n\n    :hover {\n      span:first-child {\n        font-weight: 700;\n        opacity: 1;\n      }\n    }\n  "])), function (p) {
  return p.theme.tokens.spacing03;
}));

exports.GitLabLink = GitLabLink;